<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="auto">
        <v-text-field
          v-model="keyword" 
          filled
          dense
          flat
          solo
          clearable
          label="Tìm thông tin"
          placeholder="Vd: dịch bệnh cây lúa"
          prepend-inner-icon="mdi-magnify" 
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="typeSelected"
          :items="types"
          item-text="dien_giai"
          item-value="id"
          label="Lọc theo loại"
          multiple
          filled
          dense
          flat
          solo
          clearable
          prepend-inner-icon="mdi-filter"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="selectedLevelItem"
          :items="levels"
          filled
          dense
          flat
          solo
          clearable
          label="Lọc theo mức độ"
          prepend-inner-icon="mdi-filter"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="sortSelected"
          :items="sorts"
          filled
          dense
          flat
          solo
          clearable
          label="Sắp xếp theo"
          prepend-inner-icon="mdi-sort-alphabetical-variant"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
    </v-row>
    <h4 class="text-right mb-4 font-weight-light">
      Trang <span class="primary--text">{{currentPage}}</span> 
      (Tổng <span class="primary--text">{{totalPages}}</span> trang 
      của <span class="primary--text">{{totalItems}}</span> bài viết)
    </h4>
    <h4 class="text-center mb-4 font-weight-light" v-if="!$store.state.loader && items.length==0">
      Không tìm thấy! Thử điều chỉnh lại các bộ lọc
    </h4>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="3"
        v-for="item in items" 
        :key="item.id"
      >
        <v-sheet class="rounded-lg overflow-hidden h-100">
          <v-hover v-slot="{ hover }">
            <v-card flat>
              <router-link
                :to="{ name: 'NewsView', params: { id: item.id }}"
              >
                <v-img
                  v-if="item.anh_dai_dien"
                  :src="`${apiBaseUrl}/uploads/${item.anh_dai_dien}`"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                />
                <v-img
                  v-else
                  src="@/assets/NoImage.jpg"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                />
              </router-link>
              <v-card-subtitle class="py-2">
                <span class="text-body-2 font-italic mr-4">
                  <v-icon small>mdi-clock</v-icon>
                  {{item.published_at}}, {{item.custom_created_at}}
                </span>
                <span class="text-body-2 font-italic">
                  <v-icon small>mdi-eye</v-icon>
                  {{ item.countview || 1 }}
                </span>
              </v-card-subtitle>
              <v-card-title class="py-0">
                <div class="text-body-1 font-weight-medium news-title">
                  <router-link
                    :to="{ name: 'NewsView', params: { id: item.id }}"
                    class="black--text"
                    :title="item.tieu_de"
                  >
                    {{item.tieu_de}}
                  </router-link>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  v-if="item.muc_do != null && item.muc_do != 'NORMAL'"
                  :fab="!hover"
                  :rounded="hover"
                  dark
                  :small="!hover"
                  :color="item.muc_do=='DANGER' ? 'red' : 'orange'"
                  class="news-level"
                >
                  <v-icon>mdi-alert{{item.muc_do=='DANGER' ? '-octagon' : ''}}</v-icon>
                  <span v-if="hover">{{ getLevelText(item.muc_do) }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import { mapState, mapActions } from 'vuex';
  export default {
    name: 'News',
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      loading: false,
      crumbs: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      items: [],
      types: [],
      typeSelected: null,
      levels: [
        {
          action: 'mdi-information-outline', 
          color: 'info', 
          value: 'NORMAL', 
          text: 'Bình thường'
        },
        {
          action: 'mdi-alert-octagon', 
          color: 'red', 
          value: 'DANGER', 
          text: 'Khẩn cấp'
        },
        {
          action: 'mdi-alert', 
          color: 'orange', 
          value: 'WARNING', 
          text: 'Cảnh báo'
        },
        {
          action: 'mdi-axis-arrow-info', 
          color: 'green', 
          value: 'PREDICT', 
          text: 'Dự báo'
        }
      ],
      selectedLevelItem: null,
      sorts: [
        {value: 'asc', text: 'A-Z'},
        {value: 'desc', text: 'Z-A'}
      ],
      sortSelected: null,
      keywordInput: '',
      timeout: null
    }),
    metaInfo() {
      return { 
        meta: [
          { name: 'description', content: 'Tin tức nông nghiệp'},
          { property: 'og:title', content: "Tin tức nông nghiệp"}
        ]
      }
    },
    computed: {
      ...mapState([
        'config'
      ]),
      keyword: {
        get() {
          return this.keywordInput;
        },
        set(val) {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.keywordInput = val;
            this.initialize();
          }, 1000);
        }
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      this.initialize();
      this.getTypes();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Tin nông nghiệp',
          disabled: true
        }
      ];
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if(this.typeSelected){
          params["type"] = this.typeSelected;
        }

        if(this.selectedLevelItem){
          params["level"] = this.selectedLevelItem;
        }

        if(this.sortSelected){
          params["sort"] = this.sortSelected;
        }
        
        if(this.keywordInput){
          params["keyword"] = this.keywordInput;
        }

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
        this.$vuetify.goTo(0);
      },
      initialize () {
        const app = this;
        const params = app.getRequestParams(
          app.currentPage,
        );
        app.getLoader(true);
        let request = {
          params: params
        };
        axios.get("api/v1/public/news", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      searchItems(){
        this.initialize();
      },
      getTypes () {
        axios.get("api/v1/public/news-categories")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getLevelText(value){
        let level = this.levels.find(
          element => element.value === value
        );
        return level ? level.text : '';
      }
    }
  }
</script>
<style>
  .v-image .v-image__image {
    transition: all 0.2s;
  }
  .v-image.zoom .v-image__image {
    transform: scale(1.2);
  }
  .news-level{
    position: absolute;
    top: 5px; 
    left: 4px;
  }
  .v-card__title .news-title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2; 
    -webkit-box-orient: vertical;
  }
</style>